/** IMS domainValidationReason → dashboard operator copy (HOP-2198). */
export const DOMAIN_VALIDATION_REASON_MESSAGES: Record<string, string> = {
  INTERNAL_BLACKLIST: 'Domain is in Internally Blacklist',
  CLEAROUT_SECONDARY_BLOCK: 'Clearout: Email is Disposable / Gibberish / Free Account / Role Account',
  CLEAROUT_INVALID: 'Clearout: Email is Invalid',
  CLEAROUT_UNKNOWN: 'Clearout: Email is Unknown',
  CLEAROUT_VALID_WHITELISTED: 'Clearout: Valid Email, domain added to Whitelist',
  CLEAROUT_CATCHALL_APPROVED: 'Clearout: Catchall Email, Approved',
};

/** Fallback when the IMS error carries internalCode but no domainValidationReason. */
export const VERIFY_EMAIL_INTERNAL_CODE_MESSAGES: Record<string, string> = {
  '400_verify_email_domain_not_allowed': 'Domain is not allowed for corporate email verification',
  '400_verify_email_invalid_corporate_domain': 'Clearout: Email is Invalid',
  '400_verify_email_black_listed_domain': 'Domain is in Internally Blacklist',
};

export function resolveDomainValidationErrorMessage(httpError: any): string {
  const metadata = httpError && httpError.error && httpError.error.metadata;
  const imsError = metadata && metadata.error;
  if (!imsError) {
    return 'Failed to update email';
  }

  const reason = imsError.domainValidationReason;
  if (reason && DOMAIN_VALIDATION_REASON_MESSAGES[reason]) {
    return DOMAIN_VALIDATION_REASON_MESSAGES[reason];
  }

  const internalCode = imsError.internalCode;
  if (internalCode && VERIFY_EMAIL_INTERNAL_CODE_MESSAGES[internalCode]) {
    return VERIFY_EMAIL_INTERNAL_CODE_MESSAGES[internalCode];
  }

  return imsError.displayMessage || 'Failed to update email';
}

export function resolveDomainValidationSuccessMessage(responseBody: any): string | null {
  const reason = responseBody && responseBody.domainValidationReason;
  if (reason && DOMAIN_VALIDATION_REASON_MESSAGES[reason]) {
    return DOMAIN_VALIDATION_REASON_MESSAGES[reason];
  }
  return null;
}
